export default __webpack_public_path__ + "static/media/prize-2.3beb2e56.webp";